import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/inventoryMedia/useInventoryMediaQueryKeys.ts
var t = e("inventory-media", { images: (e, t) => e && t ? [
	"images",
	e,
	t
] : ["images"] });
//#endregion
export { t as inventoryMediaQueryKeys };
